<template>
    <!--  BEGIN SIDEBAR  -->
    <div class="sidebar-wrapper sidebar-theme">
        <nav ref="menu" id="sidebar">
            <div class="shadow-bottom"></div>
            <perfect-scrollbar class="list-unstyled menu-categories" tag="ul" :options="{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true }">
                <br>
                <li class="menu">
                    <router-link to="/leaderboard" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <DashboardSVG />
                            <span>{{ t('leaderboard') }}</span>
                        </div>
                    </router-link>
                </li>

                <li class="menu">
                    <router-link to="/activity-log" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <ActivityLogSVG />
                            <span>{{ t('activity_log') }}</span>
                        </div>
                    </router-link>
                </li>

                <li class="menu hide-menu">
                    <router-link to="/events" class="dropdown-toggle " @click="toggleMobileMenu">
                        <div class="">
                            <EventSVG />
                            <span>{{ t('events') }}</span>
                        </div>
                    </router-link>
                </li>

                <li class="menu">
                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#points" aria-controls="points" aria-expanded="false">
                        <div class="">
                            <PointsSVG />
                            <span>{{ t('give_points') }}</span>
                        </div>
                        <div>
                            <ChevronRightSVG />
                        </div>
                    </a>


                    <ul id="points" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                        <li>
                            <router-link to="/points/add" @click="toggleMobileMenu">
                                {{ t('give_reward') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/my-points" @click="toggleMobileMenu">
                                {{ t('my_points') }}
                            </router-link>
                        </li>
                    </ul>
                </li>

                <li class="menu">
                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#redeem-points" aria-controls="redeem-points" aria-expanded="false">
                        <div class="">
                            <PointsSVG />
                            <span>{{ t('redeem_points') }}</span>
                        </div>
                        <div>
                            <ChevronRightSVG />
                        </div>
                    </a>
                    <ul id="redeem-points" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                        <li>
                            <router-link to="/points/redeem" @click="toggleMobileMenu">
                                {{ t('redeem_request') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/points/my-redeems" @click="toggleMobileMenu">
                                {{ t('my_request') }}
                            </router-link>
                        </li>
                    </ul>
                </li>

            </perfect-scrollbar>
        </nav>
    </div>
    <!--  END SIDEBAR  -->
</template>
<style scoped>
.hide-menu{
    display: none;
}
</style>
<script setup>
    import { onMounted, ref } from 'vue';
    import CatalogSVG from "../../svg/catalog.vue"
    import EventSVG from "../../svg/event.vue"
    import DashboardSVG from "../../svg/dashboard.vue"
    import PointsSVG from "../../svg/points.vue"
    import UsersSVG from "../../svg/users.vue"
    import LockSVG from "../../svg/lock.vue"
    import PageSVG from "../../svg/page.vue"
    import ChipSVG from "../../svg/chip.vue"
    import TeamSVG from "../../svg/team.vue"
    import ScreenSVG from "../../svg/screen.vue"
    import ChevronRightSVG from "../../svg/chevron-right.vue"
    import ActivityLogSVG from "@/components/svg/activity-log.vue"
    import { useStore } from 'vuex';
    import { useI18n } from 'vue-i18n';

    const {t} =useI18n()

    const store = useStore();
    const menu_collapse = ref('dashboard');

    onMounted(() => {
        const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
        if (selector) {
            const ul = selector.closest('ul.collapse');
            if (ul) {
                let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            } else {
                selector.click();
            }
        }
    });

    const toggleMobileMenu = () => {
        if (window.innerWidth < 991) {
            store.commit('toggleSideBar', !store.state.is_show_sidebar);
        }
    };
</script>
